import React, {
	useEffect, useState
}from "react"
import {
	Row, Pagination, Input, Button, Empty, Col, ConfigProvider
}from "antd"
import {
	newsLoadables
}from "../../../loadables"
import {
	Link
}from "react-router-dom"
import {
	useDebounce
}from "use-lodash-debounce"
import {
	newsActions
}from "../store/actions"
import {
	useDispatch, useSelector
}from "react-redux"
import i18n from "../../News/locale.js"
import byBY from 'antd/lib/locale/by_BY'
import ruRU from 'antd/lib/locale/ru_RU'
import i18nGlobal from "../../../localization"
import CustomButton from "../../../components/ButtonCustom"
import Plus from '../../../../public/Glyph_ .svg'
import './style.css'

const { Search } = Input

const PageSize = 4

const ManageNews = () => {
	const { news } = useSelector((state) => state.newsReducer)
	const dispatch = useDispatch()
	const [page, setPage] = useState(0)
	const [search, setSearch] = useState(null)
	const [searchLoading, setSearchLoading] = useState(false)
	const getNews = (params) => {
		dispatch(newsActions.getNews(params))
	}
	const deleteOneNews = (params) => {
		dispatch(newsActions.deleteNews(params))
	}
	const searchWithPause = useDebounce(search, 500)
	const isRu = useSelector((state) => state.globalReducer.isRu)

	useEffect(() => {
		onPaginationChange(1)
	}, [searchWithPause])

	useEffect(() => {
		setSearchLoading(false)
	}, [news])

	function onPaginationChange(value){
		setSearchLoading(true)
		setPage(value)
		getNews({
			PageSize : PageSize,
			Page     : value,
			Search   : search
		})
	}
	return (
		<>
			<ConfigProvider locale={ isRu?ruRU:byBY }>
				<Row
					className="search-news"
					justify="start"
					type="flex"
				>
					<Col>
						<Search
							maxLength={ 255 }
							placeholder={ i18nGlobal.find[isRu] }
							value={ search }
							onChange={ (e) => setSearch(e.target.value) }
						/>
					</Col>
					<Col
						offset={ 1 }
					>
						<Link
							to="/addNews"
						>
							<CustomButton type="orange">
								<img
									alt={ i18n.addNewsButton[isRu] }
									src={ Plus }
								/>
								<span>
									{ i18n.addNewsButton[isRu] }
								</span>
							</CustomButton>
						</Link>
					</Col>
				</Row>

				{ news && news.items && !searchLoading ? (
					news.items.length > 0 ? (
						<>
							<newsLoadables.LoadableNewsList
								isEditMode
								deleteOneNews={ deleteOneNews }
								news={ news.items }
								refrechData={ onPaginationChange }
							/>
							<Row
								justify="center"
								type="flex"
							>
								<Pagination
									current={ page }
									defaultCurrent={ 1 }
									pageSize={ PageSize }
									showSizeChanger={ false }
									total={ news.count }
									onChange={ onPaginationChange }
								/>
							</Row>
						</>
					) : (
						<Empty />
					)
				) : (
					<Empty />
				) }
			</ConfigProvider>
		</>
	)
}

export default ManageNews
